import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock, Teleport as _Teleport } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = {
  class: "trial-fund-guide__mask",
  "aria-hidden": "true"
};
const _hoisted_3 = {
  class: "trial-fund-guide__content"
};
const _hoisted_4 = {
  key: 0,
  class: "trial-fund-guide__body"
};
const _hoisted_5 = {
  key: 1,
  class: "trial-fund-guide__hint"
};
const _hoisted_6 = {
  key: 0,
  class: "trial-fund-guide__tap-hint"
};
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import AppImage from '@/components/common/AppImage.vue';
import TrialSimOrderBurst from '@/components/trial-fund/TrialSimOrderBurst.vue';
import { Z_INDEX } from '@/config/zIndex';
import { getTrialFundAssets, TRIAL_FUND_SIM_ROUTE_NAME } from '@/constants/trial-fund';
import { useLayoutBreakpoint } from '@/composables/useLayoutBreakpoint';
import { useTrialFundStore } from '@/stores/trialFund';
import { lockBodyScroll, unlockBodyScroll } from '@/composables/useBodyScrollLock';
const HOLE_PAD = 5;
const HOLE_PAD_KEFU = 10;
const BUBBLE_GAP = 12;
const BUBBLE_W = 280;
export default {
  __name: 'TrialFundGuideHost',
  setup(__props) {
    const {
      t
    } = useI18n();
    const route = useRoute();
    const router = useRouter();
    const {
      isMobile
    } = useLayoutBreakpoint();
    const trialFundStore = useTrialFundStore();
    const {
      guideActive,
      guideStep,
      simHasPendingPosition,
      simMiniCountdownLabel
    } = storeToRefs(trialFundStore);
    const guideZ = Z_INDEX.TRIAL_FUND_GUIDE_ABOVE_TAWK;
    const guideAssets = getTrialFundAssets();

    /** @type {Record<string, string>} */
    const STEP_ICON_KEY = {
      rules: 'guideHeadset',
      chartCountdown: 'guideClock',
      guess: 'guideGift',
      /** 等待开奖：礼盒挂彩带右侧 */
      countdown: 'guideGift',
      /** 返回步：箭头对齐彩带高度 */
      exit: 'guideArrow',
      feedCountdown: 'guideClock',
      kefu: 'guideHeadset',
      bye: 'guideMoneybag',
      dismissConfirm: 'guideHeadset',
      dismissBye: 'guideMoneybag'
    };
    const stepIconSrc = computed(() => {
      const key = STEP_ICON_KEY[guideStep.value];
      return key ? guideAssets[key] || '' : '';
    });

    /** 等待开奖步：礼盒在彩带右侧 */
    const ribbonIconRight = computed(() => guideStep.value === 'countdown');

    /** 猜题步手指：贴 $10 金额右下角 */
    const handFloatPos = ref(null);
    const handFloatStyle = computed(() => {
      const p = handFloatPos.value;
      if (!p || guideStep.value !== 'guess' || !guideAssets.guideHand) return null;
      return {
        left: `${p.left}px`,
        top: `${p.top}px`
      };
    });
    function measureHandFloat() {
      if (typeof document === 'undefined' || guideStep.value !== 'guess') {
        handFloatPos.value = null;
        return;
      }
      const el = document.querySelector('[data-trial-guide="guess-amount"]') || document.querySelector('.pm-outcome-sticky__promo-cta-amount') || document.querySelector('[data-trial-guide="guess"].pm-outcome-sticky__promo-cta');
      if (!el) {
        handFloatPos.value = null;
        return;
      }
      const r = el.getBoundingClientRect();
      if (!(r.width > 0 && r.height > 0)) {
        handFloatPos.value = null;
        return;
      }
      // 锚点右下角，再上移 10px
      handFloatPos.value = {
        left: r.right,
        top: r.bottom - 10
      };
    }
    const ribbonBgStyle = computed(() => {
      const bg = guideAssets.guideRibbon || '';
      if (!bg) return {};
      return {
        backgroundImage: `url(${bg})`
      };
    });

    /** 弹窗外壳：直接用 banner-bg，不用白色底 */
    const bubbleBgStyle = computed(() => {
      const bg = guideAssets.guideBannerBg || '';
      if (!bg) return {};
      return {
        backgroundImage: `url(${bg})`
      };
    });
    const holeRect = ref(null);
    /** 跳过确认时锁定气泡位置，只换文案 */
    const lockedBubbleStyle = ref(null);
    const viewport = ref({
      w: 0,
      h: 0
    });
    let rafId = 0;
    let resizeObs = null;
    let measureRetryTimer = 0;
    let measureRetryAttempts = 0;
    let guideScrollLocked = false;
    function preventGuideScroll(e) {
      // 引导层打开时禁止底层区域滚动穿透
      e.preventDefault();
    }
    function enableGuideScrollLock() {
      if (guideScrollLocked || typeof document === 'undefined') return;
      guideScrollLocked = true;
      lockBodyScroll();
      document.addEventListener('wheel', preventGuideScroll, {
        passive: false,
        capture: true
      });
      document.addEventListener('touchmove', preventGuideScroll, {
        passive: false,
        capture: true
      });
    }
    function disableGuideScrollLock() {
      if (!guideScrollLocked || typeof document === 'undefined') return;
      guideScrollLocked = false;
      document.removeEventListener('wheel', preventGuideScroll, true);
      document.removeEventListener('touchmove', preventGuideScroll, true);
      unlockBodyScroll();
    }

    /** 临时解锁 → 滚入视口 → 再锁（首页卡 / 图表倒计时） */
    async function revealAnchorThenRelock(selector) {
      disableGuideScrollLock();
      await nextTick();
      scrollGuideAnchorIntoView(selector);
      await nextTick();
      await new Promise(resolve => {
        requestAnimationFrame(() => resolve());
      });
      if (guideActive.value && isMobile.value) {
        enableGuideScrollLock();
      }
    }
    async function revealFeedCountdownAnchor() {
      await revealAnchorThenRelock('[data-trial-guide="feed-countdown"]');
    }
    async function revealChartCountdownAnchor() {
      await revealAnchorThenRelock('[data-trial-guide="chart-countdown"]');
    }

    /** @type {Record<string, string>} */
    const ANCHOR_SELECTOR = {
      rules: '',
      chartCountdown: '[data-trial-guide="chart-countdown"]',
      guess: '[data-trial-guide="guess"]',
      countdown: '[data-trial-guide="cta-countdown"]',
      exit: '[data-trial-guide="exit"]',
      feedCountdown: '[data-trial-guide="feed-countdown"]',
      // 自家 kefu FAB（Tawk 默认球已隐藏，仅列表唤起）
      kefu: '[data-trial-guide="kefu"]',
      bye: '',
      dismissConfirm: '',
      dismissBye: ''
    };

    /** 主锚点缺失时的回退（仍只取真实按钮节点；feed 倒计时不回退整卡） */
    /** @type {Record<string, string>} */
    const ANCHOR_FALLBACK = {
      countdown: '[data-trial-guide="guess"]',
      kefu: '.tawk-mobile, iframe[title*="chat widget"], iframe[title*="Chat"]'
    };

    /** @type {Record<string, 'tap' | 'action' | 'choice'>} */
    const STEP_MODE = {
      rules: 'tap',
      chartCountdown: 'tap',
      guess: 'action',
      countdown: 'tap',
      exit: 'action',
      feedCountdown: 'tap',
      kefu: 'tap',
      bye: 'tap',
      dismissConfirm: 'choice',
      dismissBye: 'tap'
    };
    const bubbleTitle = computed(() => {
      const step = guideStep.value;
      if (!step) return '';
      return t(`trialFund.guide.steps.${step}.title`);
    });
    const bubbleBody = computed(() => {
      const step = guideStep.value;
      if (!step) return '';
      return t(`trialFund.guide.steps.${step}.body`);
    });
    const bubbleHint = computed(() => {
      const step = guideStep.value;
      if (!step || step === 'dismissConfirm') return '';
      return t(`trialFund.guide.steps.${step}.hint`);
    });

    /** 挖空框：贴合锚点 + HOLE_PAD */
    const holeStyle = computed(() => {
      const r = holeRect.value;
      if (!r) return null;
      return {
        left: `${r.left}px`,
        top: `${r.top}px`,
        width: `${r.width}px`,
        height: `${r.height}px`
      };
    });

    /** 点击遮罩方孔（与高亮框同尺寸；孔内无节点 → 事件穿透） */
    const shadeTop = computed(() => {
      const r = holeRect.value;
      if (!r) return null;
      return {
        left: '0',
        top: '0',
        right: '0',
        height: `${Math.max(0, r.top)}px`
      };
    });
    const shadeLeft = computed(() => {
      const r = holeRect.value;
      if (!r) return null;
      return {
        left: '0',
        top: `${Math.max(0, r.top)}px`,
        width: `${Math.max(0, r.left)}px`,
        height: `${r.height}px`
      };
    });
    const shadeRight = computed(() => {
      const r = holeRect.value;
      const vw = viewport.value.w || 0;
      if (!r) return null;
      const rightEdge = r.left + r.width;
      return {
        left: `${rightEdge}px`,
        top: `${Math.max(0, r.top)}px`,
        width: `${Math.max(0, vw - rightEdge)}px`,
        height: `${r.height}px`
      };
    });
    const shadeBottom = computed(() => {
      const r = holeRect.value;
      if (!r) return null;
      const top = r.top + r.height;
      return {
        left: '0',
        top: `${top}px`,
        right: '0',
        height: `calc(100vh - ${top}px)`
      };
    });
    const isDismissUiStep = computed(() => guideStep.value === 'dismissConfirm' || guideStep.value === 'dismissBye');

    /** 结束祝福 / 跳过确认分支不展示「跳过」 */
    const showSkipButton = computed(() => Boolean(guideStep.value) && !isDismissUiStep.value && guideStep.value !== 'bye');
    const bubbleStyle = computed(() => {
      // 跳过确认 / 跳过拜拜：弹窗始终屏幕居中
      if (isDismissUiStep.value) {
        return buildCenteredBubbleStyle();
      }
      return buildBubbleStyle();
    });
    function buildCenteredBubbleStyle() {
      const vw = viewport.value.w || (typeof window !== 'undefined' ? window.innerWidth : 375);
      const vh = viewport.value.h || (typeof window !== 'undefined' ? window.innerHeight : 667);
      const width = Math.min(BUBBLE_W, vw - 32);
      return {
        width: `${width}px`,
        left: `${Math.max(16, (vw - width) / 2)}px`,
        top: '50%',
        transform: 'translateY(-50%)'
      };
    }
    function buildBubbleStyle() {
      const vw = viewport.value.w || (typeof window !== 'undefined' ? window.innerWidth : 375);
      const vh = viewport.value.h || (typeof window !== 'undefined' ? window.innerHeight : 667);
      const width = Math.min(BUBBLE_W, vw - 32);
      const r = holeRect.value;
      let top;
      let left = (vw - width) / 2;
      if (r) {
        left = Math.min(Math.max(16, r.left + r.width / 2 - width / 2), vw - width - 16);
        const below = r.bottom + BUBBLE_GAP + 8;
        const above = r.top - BUBBLE_GAP - 180;
        if (below + 180 < vh - 24) top = below;else if (above > 36) top = Math.max(36, above);else top = Math.min(below, vh - 200);
      } else {
        top = Math.max(vh * 0.28, 48);
      }
      top = Math.max(16, top);
      left = Math.min(left, vw - width - 16);
      left = Math.max(16, left);

      // 第二步（图表倒计时）：弹窗整体右移 15% 视口宽
      if (guideStep.value === 'chartCountdown') {
        left = Math.min(left + vw * 0.15, vw - width - 16);
      }

      // 第五步（返回）：上移，使彩带箭头与返回按钮对齐（框选含「首页」，不以整段中心对齐）
      if (guideStep.value === 'exit' && r) {
        const bubblePadX = 12;
        const bubblePadY = 12;
        const ribbonH = 32;
        // 箭头中心约在 ribbon-wrap 左缘 +5px（transform: -50% + 5px）
        const arrowCenterOffsetX = bubblePadX + 5;
        const arrowCenterOffsetY = bubblePadY + ribbonH / 2;
        const backCenterX = r.left + Math.min(14, r.width / 2);
        left = Math.max(16, Math.min(backCenterX - arrowCenterOffsetX, vw - width - 16));
        left = Math.min(left + vw * 0.2, vw - width - 16);
        top = Math.max(16, r.top + r.height / 2 - arrowCenterOffsetY);
        return {
          width: `${width}px`,
          left: `${left}px`,
          top: `${top}px`
        };
      }

      // 第四步（等待开奖）：弹窗底边在倒计时框上方约 20px，再左移 15% 视口宽
      if (guideStep.value === 'countdown' && r) {
        left = Math.max(16, Math.min(r.left + r.width / 2 - width / 2, vw - width - 16));
        left = Math.max(16, left - vw * 0.15);
        return {
          width: `${width}px`,
          left: `${left}px`,
          top: `${Math.max(16, r.top - 20)}px`,
          transform: 'translateY(-100%)'
        };
      }
      return {
        width: `${width}px`,
        left: `${left}px`,
        top: `${top}px`
      };
    }
    function syncViewport() {
      if (typeof window === 'undefined') return;
      viewport.value = {
        w: window.innerWidth,
        h: window.innerHeight
      };
    }

    /**
     * @returns {Element | null}
     */
    function pickKefuAnchorEl() {
      if (typeof document === 'undefined' || typeof window === 'undefined') return null;
      const vw = window.innerWidth || 0;
      const vh = window.innerHeight || 0;
      const maxArea = Math.max(1, vw * vh * 0.28);

      /** @type {Element[]} */
      const candidates = [];
      document.querySelectorAll(['[data-trial-guide="kefu"]', '.tawk-mobile', '.tawk-button-container', '.tawk-button', '#tawkchat-minified-wrapper', '#tawkchat-minified-container', 'iframe[title*="chat widget"]', 'iframe[title*="Chat"]', 'iframe[title*="chat"]'].join(',')).forEach(el => candidates.push(el));

      // 几何兜底：右下角 fixed/absolute 的圆形浮标（Tawk DOM 类名常变）
      document.querySelectorAll('body *').forEach(el => {
        if (!(el instanceof HTMLElement)) return;
        if (candidates.includes(el)) return;
        if (el.closest('.trial-fund-guide')) return;
        const cs = window.getComputedStyle(el);
        if (cs.position !== 'fixed' && cs.position !== 'absolute') return;
        if (cs.visibility === 'hidden' || cs.display === 'none' || cs.opacity === '0') return;
        const r = el.getBoundingClientRect();
        if (r.width < 36 || r.height < 36) return;
        if (r.width > 96 || r.height > 96) return;
        // 右下区域
        if (r.left < vw * 0.55) return;
        if (r.top < vh * 0.55) return;
        if (r.bottom > vh + 4 || r.right > vw + 4) return;
        candidates.push(el);
      });
      let best = null;
      let bestScore = -1;
      for (const el of candidates) {
        if (!document.contains(el)) continue;
        /** @type {Element} */
        let target = el;
        let rect = el.getBoundingClientRect();
        if (!(rect.width > 0 && rect.height > 0) && el.parentElement) {
          const parent = el.parentElement;
          const pr = parent.getBoundingClientRect();
          if (pr.width > 0 && pr.height > 0 && pr.width * pr.height < maxArea) {
            target = parent;
            rect = pr;
          }
        }
        const area = rect.width * rect.height;
        if (!(area > 0) || area >= maxArea) continue;
        if (rect.bottom < vh * 0.4) continue;
        // 越靠右下、越接近正方形分越高
        const squareness = 1 - Math.min(1, Math.abs(rect.width - rect.height) / Math.max(rect.width, rect.height));
        const corner = rect.right / Math.max(1, vw) * 0.5 + rect.bottom / Math.max(1, vh) * 0.5;
        const score = area * 0.01 + squareness * 80 + corner * 40;
        if (score > bestScore) {
          best = target;
          bestScore = score;
        }
      }
      return best;
    }

    /** @returns {Element[]} */
    function resolveAnchorEls() {
      const step = guideStep.value;
      if (!step || typeof document === 'undefined') return [];
      if (step === 'kefu') {
        const el = pickKefuAnchorEl();
        return el ? [el] : [];
      }
      const primary = ANCHOR_SELECTOR[step];
      if (!primary) return [];
      let list = Array.from(document.querySelectorAll(primary)).filter(el => document.contains(el));
      if (!list.length) {
        const fallback = ANCHOR_FALLBACK[step];
        if (fallback) {
          list = Array.from(document.querySelectorAll(fallback)).filter(el => document.contains(el));
        }
      }
      return list;
    }

    /**
     * @param {Element[]} els
     * @returns {{ left: number, top: number, width: number, height: number, bottom: number, right: number } | null}
     */
    function unionHoleFromEls(els) {
      const vw = viewport.value.w || 0;
      const vh = viewport.value.h || 0;
      const pad = guideStep.value === 'kefu' ? HOLE_PAD_KEFU : HOLE_PAD;
      let left = Infinity;
      let top = Infinity;
      let right = -Infinity;
      let bottom = -Infinity;
      let any = false;
      for (const el of els) {
        const rect = el.getBoundingClientRect();
        if (!(rect.width > 0 && rect.height > 0)) continue;
        any = true;
        left = Math.min(left, rect.left);
        top = Math.min(top, rect.top);
        right = Math.max(right, rect.right);
        bottom = Math.max(bottom, rect.bottom);
      }
      if (!any) return null;
      // 客服球近似圆形：用正方形外接框，虚线圆更好贴合
      if (guideStep.value === 'kefu') {
        const cx = (left + right) / 2;
        const cy = (top + bottom) / 2;
        const side = Math.max(right - left, bottom - top) + pad * 2;
        left = cx - side / 2;
        top = cy - side / 2;
        right = cx + side / 2;
        bottom = cy + side / 2;
      } else {
        left -= pad;
        top -= pad;
        right += pad;
        bottom += pad;
      }
      left = Math.max(0, left);
      top = Math.max(0, top);
      right = Math.min(vw || right, right);
      bottom = Math.min(vh || bottom, bottom);
      return {
        left,
        top,
        width: Math.max(0, right - left),
        height: Math.max(0, bottom - top),
        bottom,
        right
      };
    }
    function clearMeasureRetry() {
      if (measureRetryTimer) {
        clearTimeout(measureRetryTimer);
        measureRetryTimer = 0;
      }
      measureRetryAttempts = 0;
    }
    function scrollGuideAnchorIntoView(selector = '[data-trial-guide="feed-countdown"]') {
      if (typeof document === 'undefined') return;
      const primary = document.querySelector(selector);
      const card = selector.includes('feed-countdown') ? document.querySelector('[data-trial-guide="feed-card"]') : null;
      const el = primary || card;
      if (!el || typeof el.scrollIntoView !== 'function') return;
      try {
        el.scrollIntoView({
          block: 'center',
          inline: 'nearest',
          behavior: 'auto'
        });
      } catch {
        /* ignore */
      }
    }
    function scheduleFeedCountdownRetry() {
      if (measureRetryTimer) return;
      measureRetryTimer = window.setTimeout(() => {
        measureRetryTimer = 0;
        if (!guideActive.value || guideStep.value !== 'feedCountdown') {
          clearMeasureRetry();
          return;
        }
        measureRetryAttempts += 1;
        void (async () => {
          await revealFeedCountdownAnchor();
          syncViewport();
          const next = unionHoleFromEls(resolveAnchorEls());
          if (next) {
            holeRect.value = next;
            lockedBubbleStyle.value = buildBubbleStyle();
            clearMeasureRetry();
            return;
          }
          if (measureRetryAttempts < 40) {
            scheduleFeedCountdownRetry();
          } else {
            clearMeasureRetry();
          }
        })();
      }, 80);
    }

    /** Tawk 异步注入：客服步轮询等待可测锚点 */
    function scheduleKefuAnchorRetry() {
      if (measureRetryTimer) return;
      measureRetryTimer = window.setTimeout(() => {
        measureRetryTimer = 0;
        if (!guideActive.value || guideStep.value !== 'kefu') {
          clearMeasureRetry();
          return;
        }
        measureRetryAttempts += 1;
        try {
          const api = typeof window !== 'undefined' ? window.Tawk_API : null;
          if (api && typeof api.showWidget === 'function') api.showWidget();
        } catch {
          /* ignore */
        }
        syncViewport();
        const next = unionHoleFromEls(resolveAnchorEls());
        if (next) {
          holeRect.value = next;
          lockedBubbleStyle.value = buildBubbleStyle();
          clearMeasureRetry();
          return;
        }
        if (measureRetryAttempts < 50) {
          scheduleKefuAnchorRetry();
        } else {
          clearMeasureRetry();
          lockedBubbleStyle.value = buildBubbleStyle();
        }
      }, 120);
    }
    function measureHole() {
      syncViewport();
      // 跳过确认 / 拜拜：保持当前高亮；弹窗由 bubbleStyle 居中
      if (isDismissUiStep.value) return;
      const next = unionHoleFromEls(resolveAnchorEls());
      holeRect.value = next;
      measureHandFloat();
      if (next) {
        lockedBubbleStyle.value = buildBubbleStyle();
        clearMeasureRetry();
        return;
      }
      // 回首页后福利卡/倒计时可能稍后才挂载：只等真实倒计时节点，不框整张卡
      if (guideStep.value === 'feedCountdown') {
        scheduleFeedCountdownRetry();
        return;
      }
      if (guideStep.value === 'kefu') {
        scheduleKefuAnchorRetry();
        return;
      }
      lockedBubbleStyle.value = buildBubbleStyle();
    }
    function scheduleMeasure() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        rafId = 0;
        measureHole();
      });
    }
    function onMaskClick() {
      const mode = STEP_MODE[guideStep.value];
      if (mode === 'tap') {
        if (guideStep.value === 'dismissBye' || guideStep.value === 'bye') {
          trialFundStore.finishGuide();
          if (route.name !== 'Home') {
            router.push({
              name: 'Home'
            });
          }
          return;
        }
        trialFundStore.advanceGuide();
      }
    }
    function onCloseClick() {
      trialFundStore.requestGuideDismiss();
    }
    function onKeepGuide() {
      trialFundStore.cancelGuideDismiss();
    }
    function onConfirmDismiss() {
      trialFundStore.confirmGuideDismiss();
    }
    watch(() => [guideActive.value, isMobile.value], ([active, mobile]) => {
      if (active && mobile) enableGuideScrollLock();else disableGuideScrollLock();
    }, {
      immediate: true
    });
    watch(() => [guideActive.value, guideStep.value, simHasPendingPosition.value, route.fullPath], async () => {
      if (!guideActive.value || !isMobile.value) return;
      if (guideStep.value !== 'feedCountdown' && guideStep.value !== 'kefu') {
        clearMeasureRetry();
      }
      await nextTick();
      if (guideStep.value === 'feedCountdown') {
        await revealFeedCountdownAnchor();
      } else if (guideStep.value === 'chartCountdown') {
        await revealChartCountdownAnchor();
      } else if (guideStep.value === 'kefu') {
        try {
          const api = typeof window !== 'undefined' ? window.Tawk_API : null;
          if (api && typeof api.showWidget === 'function') api.showWidget();
        } catch {
          /* ignore */
        }
      }
      scheduleMeasure();
      // 竞猜成功自动推进
      if (guideStep.value === 'guess' && simHasPendingPosition.value) {
        trialFundStore.onGuideGuessPlaced();
      }
      // 离开模拟盘
      if ((guideStep.value === 'exit' || guideStep.value === 'countdown') && route.name !== TRIAL_FUND_SIM_ROUTE_NAME) {
        trialFundStore.onGuideLeftSimPage();
      }
    }, {
      immediate: true
    });
    watch(simMiniCountdownLabel, () => {
      if (guideActive.value && guideStep.value === 'feedCountdown') {
        scheduleMeasure();
      }
    });
    watch(isMobile, mobile => {
      if (!mobile && guideActive.value) {
        trialFundStore.closeGuide({
          persistDone: false
        });
      }
    });
    onMounted(() => {
      syncViewport();
      window.addEventListener('resize', scheduleMeasure, {
        passive: true
      });
      window.addEventListener('scroll', scheduleMeasure, {
        passive: true,
        capture: true
      });
      if (typeof ResizeObserver !== 'undefined') {
        resizeObs = new ResizeObserver(() => scheduleMeasure());
        resizeObs.observe(document.body);
      }
    });
    onUnmounted(() => {
      window.removeEventListener('resize', scheduleMeasure);
      window.removeEventListener('scroll', scheduleMeasure, true);
      if (rafId) cancelAnimationFrame(rafId);
      clearMeasureRetry();
      disableGuideScrollLock();
      resizeObs?.disconnect();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_unref(guideActive) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "trial-fund-guide",
        style: _normalizeStyle({
          zIndex: String(_unref(guideZ))
        }),
        role: "dialog",
        "aria-label": bubbleTitle.value
      }, [_createElementVNode("div", _hoisted_2, [holeRect.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", {
        class: "trial-fund-guide__shade trial-fund-guide__shade--top",
        style: _normalizeStyle(shadeTop.value),
        onClick: onMaskClick
      }, null, 4), _createElementVNode("div", {
        class: "trial-fund-guide__shade trial-fund-guide__shade--left",
        style: _normalizeStyle(shadeLeft.value),
        onClick: onMaskClick
      }, null, 4), _createElementVNode("div", {
        class: "trial-fund-guide__shade trial-fund-guide__shade--right",
        style: _normalizeStyle(shadeRight.value),
        onClick: onMaskClick
      }, null, 4), _createElementVNode("div", {
        class: "trial-fund-guide__shade trial-fund-guide__shade--bottom",
        style: _normalizeStyle(shadeBottom.value),
        onClick: onMaskClick
      }, null, 4), _createElementVNode("div", {
        class: _normalizeClass(["trial-fund-guide__focus-ring", {
          'trial-fund-guide__focus-ring--round': _unref(guideStep) === 'kefu'
        }]),
        style: _normalizeStyle(holeStyle.value)
      }, null, 6), _unref(guideStep) === 'kefu' ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "trial-fund-guide__hole-block",
        style: _normalizeStyle(holeStyle.value),
        "aria-hidden": "true",
        onClick: onMaskClick
      }, null, 4)) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "trial-fund-guide__shade trial-fund-guide__shade--full",
        onClick: onMaskClick
      }))]), showSkipButton.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "trial-fund-guide__skip",
        onClick: _withModifiers(onCloseClick, ["stop"])
      }, _toDisplayString(_ctx.$t('trialFund.guide.skip')), 1)) : _createCommentVNode("", true), handFloatStyle.value ? (_openBlock(), _createBlock(AppImage, {
        key: 1,
        src: _unref(guideAssets).guideHand,
        alt: "",
        class: "trial-fund-guide__hand-float",
        style: _normalizeStyle(handFloatStyle.value),
        eager: ""
      }, null, 8, ["src", "style"])) : _createCommentVNode("", true), _unref(guideStep) === 'countdown' ? (_openBlock(), _createBlock(TrialSimOrderBurst, {
        key: 2,
        "burst-key": 1,
        "origin-x": 0.5,
        "origin-y": 0.5,
        "z-index": 10
      })) : _createCommentVNode("", true), bubbleStyle.value ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: "trial-fund-guide__panel",
        style: _normalizeStyle(bubbleStyle.value)
      }, [_createElementVNode("div", {
        class: "trial-fund-guide__bubble",
        style: _normalizeStyle(bubbleBgStyle.value),
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }, [stepIconSrc.value || bubbleTitle.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["trial-fund-guide__ribbon-wrap", {
          'trial-fund-guide__ribbon-wrap--icon-right': ribbonIconRight.value
        }])
      }, [stepIconSrc.value ? (_openBlock(), _createBlock(AppImage, {
        key: 0,
        src: stepIconSrc.value,
        alt: "",
        class: _normalizeClass(["trial-fund-guide__step-icon", {
          'trial-fund-guide__step-icon--right': ribbonIconRight.value,
          'trial-fund-guide__step-icon--ribbon-h': _unref(guideStep) === 'exit'
        }]),
        eager: ""
      }, null, 8, ["src", "class"])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["trial-fund-guide__ribbon", {
          'trial-fund-guide__ribbon--flip-y': ribbonIconRight.value
        }]),
        style: _normalizeStyle(ribbonBgStyle.value)
      }, [bubbleTitle.value ? (_openBlock(), _createElementBlock("p", {
        key: 0,
        class: _normalizeClass(["trial-fund-guide__ribbon-title", {
          'trial-fund-guide__ribbon-title--right': ribbonIconRight.value
        }])
      }, _toDisplayString(bubbleTitle.value), 3)) : _createCommentVNode("", true)], 6)], 2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [bubbleBody.value ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(bubbleBody.value), 1)) : _createCommentVNode("", true), _unref(guideStep) === 'dismissConfirm' ? (_openBlock(), _createElementBlock("p", _hoisted_5, [_createElementVNode("button", {
        type: "button",
        class: "trial-fund-guide__hint-link",
        onClick: _withModifiers(onKeepGuide, ["stop"])
      }, _toDisplayString(_ctx.$t('trialFund.guide.dismissKeep')), 1), _cache[1] || (_cache[1] = _createElementVNode("span", {
        class: "trial-fund-guide__hint-sep",
        "aria-hidden": "true"
      }, "·", -1)), _createElementVNode("button", {
        type: "button",
        class: "trial-fund-guide__hint-link",
        onClick: _withModifiers(onConfirmDismiss, ["stop"])
      }, _toDisplayString(_ctx.$t('trialFund.guide.dismissConfirmAction')), 1)])) : _createCommentVNode("", true)])], 4), bubbleHint.value ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(bubbleHint.value), 1)) : _createCommentVNode("", true)], 4)) : _createCommentVNode("", true)], 12, _hoisted_1)) : _createCommentVNode("", true)]);
    };
  }
};